import { render, staticRenderFns } from "./AksesKontrol.vue?vue&type=template&id=62c4d03e"
import script from "./AksesKontrol.vue?vue&type=script&lang=js"
export * from "./AksesKontrol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports